import React, { useCallback } from 'react';
import { Button } from 'design-system/Button';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { UnavailableOnWebModal } from 'utils/packages/UnavailableOnWebModal';
import { isWeb } from '../../../../constants';
const RentReportingStartButton = ({ brandReversed }) => {
    const navigation = useMainStackNavigation();
    const onPressStartReporting = useCallback(() => {
        if (isWeb) {
            UnavailableOnWebModal.show('emma://rent-reporting', 'Manage rent reporting');
        }
        else {
            navigation.navigateDeprecated('RentReportingOnboarding');
        }
    }, []);
    return (<Button onPress={onPressStartReporting} square {...(brandReversed ? { brandReversed: true } : { brandLight: true })} title="Start reporting"/>);
};
export default RentReportingStartButton;
